module.exports = __webpack_public_path__ + "static/media/loyalty-logo.0d188955.png";